const icons = [
    "summit",
    "cooperation",
    "money",
    "goal",
    "idea",
    "trophy",
    "puzzle",
    "compass",
    "globe",
    "rocket",
    "science",
    "message",
    "book",
];

export default { icons };
export { icons };
